var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_back_ios-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.046,
    height: 60.045,
    viewBox: "0 0 60.046 60.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M0,0H60.046V60.045H0Z",
    fill: "none",
    opacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M32.2,3.542a3.126,3.126,0,0,0-4.428,0L6.979,24.332a2.491,2.491,0,0,0,0,3.528L27.77,48.65A3.131,3.131,0,1,0,32.2,44.222L14.085,26.084,32.224,7.945A3.118,3.118,0,0,0,32.2,3.542Z",
    transform: "translate(9.383 3.939)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/backArrowIcon.be68ae40.svg";
export { ForwardRef as ReactComponent };